module.exports = __webpack_public_path__ + "resources/feature-icon-6-c30a0eee5a0fb373b617698d235d059d.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/feature-icon-6.png
// module id = 71
// module chunks = 0